import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const RenameModal = ({ isOpen, onClose, file, onRename }) => {
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && file) {
      // Extraer el nombre sin la extensión para facilitar la edición
      const currentName = file.displayName || file.Key || file.name || '';
      const lastDotIndex = currentName.lastIndexOf('.');
      const nameWithoutExtension = lastDotIndex > 0 ? currentName.substring(0, lastDotIndex) : currentName;
      setNewName(nameWithoutExtension);
    }
  }, [isOpen, file]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;

    setLoading(true);
    try {
      // Mantener la extensión original
      const currentName = file.displayName || file.Key || file.name || '';
      const lastDotIndex = currentName.lastIndexOf('.');
      const extension = lastDotIndex > 0 ? currentName.substring(lastDotIndex) : '';
      const fullNewName = newName.trim() + extension;

      const success = await onRename(file, fullNewName);
      if (success) {
        onClose();
      }
    } catch (error) {
      console.error('Error al renombrar:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  const currentName = file?.displayName || file?.Key || file?.name || '';
  const lastDotIndex = currentName.lastIndexOf('.');
  const extension = lastDotIndex > 0 ? currentName.substring(lastDotIndex) : '';

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Renombrar archivo">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="fileName" className="block text-sm font-medium text-gray-300 mb-2">
            Nuevo nombre
          </label>
          <div className="flex items-center">
            <input
              type="text"
              id="fileName"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              className="flex-1 px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Nombre del archivo"
              disabled={loading}
              autoFocus
            />
            {extension && (
              <span className="ml-2 text-gray-400 font-mono">
                {extension}
              </span>
            )}
          </div>
          <p className="mt-1 text-xs text-gray-500">
            La extensión se mantendrá automáticamente
          </p>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-gray-300 bg-gray-600 hover:bg-gray-700 rounded-md transition-colors disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading || !newName.trim()}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors disabled:opacity-50"
          >
            {loading ? 'Renombrando...' : 'Renombrar'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default RenameModal; 